import React from "react"

const PageTitle = ({ title, level }) => {
  const TagName = `h${Math.max(1, Math.min(6, level))}`

  return <TagName className="relative text-2xl font-bold text-black uppercase">{title}</TagName>
}

export default PageTitle
